// src/components/ExperienceModal.js
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  FormControl,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import calendar from "../../assets/icon/calendarblack.png";
import dayjs from "dayjs";
export default function ExperienceModal({ open, handleClose, onSave, editData }) {
  const [experienceData, setExperienceData] = useState({
    salonName: "",
    fromDate: null,
    toDate: null,
    designation: "",
    city: "",
  });

  useEffect(() => {
    if (editData) {
      setExperienceData({
        ...editData,
        fromDate: editData.fromDate ? dayjs(editData.fromDate) : null,
        toDate: editData.toDate ? dayjs(editData.toDate) : null,
      });
    } else {
      setExperienceData({
        salonName: "",
        fromDate: null,
        toDate: null,
        designation: "",
        city: "",
      });
    }
  }, [editData]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setExperienceData({ ...experienceData, [name]: value });
  };
  const handleAdd = () => {
    onSave({
      ...experienceData,
      fromDate: experienceData.fromDate
        ? dayjs(experienceData.fromDate).format("YYYY-MM-DD")
        : null,
      toDate: experienceData.toDate
        ? dayjs(experienceData.toDate).format("YYYY-MM-DD")
        : null,
    });
    handleClose();
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: { xs: "95%", sm: 360 },
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "600",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "#01008B",
        }}
      >
        Add Experience
        <IconButton onClick={handleClose} sx={{}}>
          <CloseIcon sx={{ fontSize: "25px" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 2 }}>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid item xs={12} md={12}>
            <TextField
              label="Salon Name"
              name="salonName"
              value={experienceData.salonName}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} md={12} sm={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Date of Joining"
                value={experienceData.fromDate}
                onChange={(newValue) =>
                  setExperienceData((prev) => ({
                    ...prev,
                    fromDate: newValue,
                  }))
                }
                slotProps={{ textField: { size: "small", fullWidth: true } }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={12} sm={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Relieving Date"
                value={experienceData.toDate}
                onChange={(newValue) =>
                  setExperienceData((prev) => ({
                    ...prev,
                    toDate: newValue,
                  }))
                }
                slotProps={{ textField: { size: "small", fullWidth: true } }}
              />{" "}
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              label="Designation"
              name="designation"
              value={experienceData.designation}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              label="City"
              name="city"
              value={experienceData.city}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
          p: 2,
        }}
      >
        <Button variant="contained" onClick={handleAdd} fullWidth>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
